export enum TABLE_HEADER {
  REQUEST_DATE = 'Created',
  URGENT = 'Urgent',
  REQUEST_DETAIL = 'Request detail',
  PENDING_ACTION = 'actions',
  INITIATOR = 'Initiator',
  PROCESS_DEFINITION_KEY = 'Process definition key',
  ENTITY_Id = 'Number',
  GROUP_ID = 'Approval group',
  OWNER_NAME = 'Approver',
  STATUS = 'Status',
  REQUEST_TYPE = 'Request type',
  TASK_DISPLAY_ID = 'Request ID',
  GSAC_ID = 'Support ticket',
  APPROVER = 'Approver',
  COMPLETED = 'Completed',
  COMPLETION_TIME = 'Completion time',
}

export interface EmptyStateProps {
  header: string;
  description: string;
  imageUrl?: string;
  renderImage?: () => React.ReactNode;
}

export const emptyStateProps: EmptyStateProps = {
  header: '',
  description: 'No requests to show',
};

export const auditTrailEmptyStateProps = {
  header: '',
  description: 'No Audits',
};

export const closedTaskEmptyStateProps: EmptyStateProps = {
  header: '',
  description: 'No previous requests to show',
};

export const DATE_TIME_FORMAT = 'MMM dd, yyyy, hh:mm aa xxx';

export const DATE_FORMAT = 'MMM dd, yyyy';

export const DEFAULT_TABLE_ROWS = 8;

export const CLOSED_TASKS_TABLE_ROWS = 16;

export const DEFAULT_TABLE_PAGE_SELECT = 1;

export enum TABLE_COLUMN_KEYS {
  CREATED_DATE = 'date',
  TASK_NUMBER = 'taskNumber',
  URGENT = 'urgent',
  BUSINESS_KEY = 'businessKey',
  REQUEST_TYPE = 'requestType',
  INITIATOR = 'initiator',
  APPROVER = 'approver',
  STATUS = 'status',
  ACTION = 'action',
  COMPLETED = 'completed',
  COMPLETION_TIME = 'completionTime',
  GSAC_ID = 'gsacId',
  CHECKBOX = 'checkbox',
  GROUP_ID = 'groupId',
}
